<mat-tab-group (selectedTabChange)="activeTabName = $event?.tab?.textLabel"
               matDialogTitle
               mat-no-ink
               dynamicHeight="true"
               class="tab-header">
    <mat-tab label="Details">
        <ng-template mat-tab-label>
            {{ 'transaction_details_modal_tabs_details' | translate }}
        </ng-template>
    </mat-tab>
    <mat-tab label="Comments">
        <ng-template mat-tab-label>
            {{ 'transaction_details_modal_tabs_comments' | translate }}
        </ng-template>
    </mat-tab>
    <mat-tab label="History">
        <ng-template mat-tab-label>
            {{ 'transaction_details_modal_tabs_history' | translate }}
        </ng-template>
    </mat-tab>
</mat-tab-group>

<mat-dialog-content *ngLet="{
                        loading: loading$ | async
                    } as state">
    <section [hidden]="activeTabName !== 'Details'">
        <h4>
            {{'transaction_details_modal_transaction' | translate}}: {{queueItem.key}}
        </h4>
        <div class="pad-bottom-sm layout-row layout-wrap">
            <div [ngClass]="isQueueSchemaDefinitionsEnabled ? 'flex-30' : 'flex-50'">
                <ui-json-formatter [data]="queueItem.specificContent"
                                   [levelsOpen]="1"
                                   [key]="'transaction_details_specific_data' | translate"
                                   [objectPlaceholder]="'global_json_object_placeholder' | translate"
                                   [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
                </ui-json-formatter>
            </div>
            <div [ngClass]="isQueueSchemaDefinitionsEnabled ? 'flex-30' : 'flex-50'">
                <ui-json-formatter [data]="queueItem.output"
                                   [levelsOpen]="1"
                                   [key]="'transaction_details_output_data' | translate"
                                   [objectPlaceholder]="'global_json_object_placeholder' | translate"
                                   [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
                </ui-json-formatter>
            </div>
            <div class="flex-30" [hidden]="!isQueueSchemaDefinitionsEnabled">
                <ui-json-formatter [data]="queueItem.analytics"
                                   [levelsOpen]="1"
                                   [key]="'transaction_details_analytics_data' | translate"
                                   [objectPlaceholder]="'global_json_object_placeholder' | translate"
                                   [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
                </ui-json-formatter>
            </div>
        </div>
        <div *ngIf="queueItem.progress"
             class="pad-bottom-sm">
            <label class="text-grey">{{ 'transaction_details_in_progress_progress' | translate }}:</label> {{
            queueItem.progress }}
        </div>
        <div *ngIf="queueItem.processingException"
             class="pad-bottom-sm">
            <label translate
                   class="text-grey">
                transaction_details_in_progress_exception
            </label>
            <ul>
                <li>
                    <span class="text-grey">{{ 'transaction_details_in_progress_reason' | translate }}:</span>
                    {{queueItem.processingException.reason}}
                </li>
                <li *ngIf="queueItem.processingException.details">
                    <span class="text-grey"> {{ 'transaction_details_in_progress_details' | translate }}: </span>
                    {{queueItem.processingException.details}}
                </li>
            </ul>
        </div>
        <ui-transaction-attempts [queueItem]="queueItem"></ui-transaction-attempts>
    </section>
    <section [hidden]="activeTabName !== 'Comments'">
        <form #formDirective="ngForm"
              [formGroup]="formGroup"
              [uiAuthorize]="'Transactions.Edit'"
              (submit)="onSubmitComment($event);"
              class="add-comment">
            <mat-form-field>
                <textarea [placeholder]="'transaction_details_comment_new_comment' | translate"
                          matInput
                          formControlName="text"
                          name="text"
                          required>
                </textarea>
                <mat-hint *ngIf="!formGroup.get('text')!.pristine &&
                                formGroup.get('text')!.hasError('maxlength')"
                          [translateParams]="{
                                max: formGroup.get('text')!.getError('maxlength').requiredLength
                            }"
                          translate
                          class="errorMessage">
                    transaction_details_comment_new_comment_warning
                </mat-hint>
            </mat-form-field>
            <div class="button-container">
                <button [spinnerButtonLoading]="state.loading"
                        [disabled]="state.loading ||
                                    formGroup.invalid"
                        ui-spinner-button
                        mat-button
                        type="submit">
                    {{ 'transaction_details_comment_add_comment' | translate }}
                </button>
            </div>
        </form>
        <ui-comments *ngIf="comments$ | async as comments"
                     [comments]="comments"
                     [service]="queueItemComment"
                     (removed)="reload$.next()"
                     editPermission="Transactions.Edit">
        </ui-comments>
    </section>
    <section [hidden]="activeTabName !== 'History'">
        <ui-transaction-events [queueItem]="queueItem"></ui-transaction-events>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
